import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { Button } from 'primereact/button';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';
import useAuth from 'hooks/useAuth';

import useAddPage from 'hooks/useAddPage';
const ItemtypetreatmentsAddPage = (props) => {
		const auth = useAuth();
	const app = useApp();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		itemtypeid: yup.string().required().label("Itemtypeid"),
		treatmentid: yup.string().required().label("Treatmentid"),
		pricemultiplier: yup.number().nullable().label("Pricemultiplier"),
		partnerid: yup.string().nullable().label("Partnerid"),
		userid: yup.number().nullable().label("Userid")
	});
	
	//form default values
	const formDefaultValues = {
		itemtypeid: '', 
		treatmentid: '', 
		pricemultiplier: "((1.00))", 
		partnerid: '', 
		userid: auth.userId, 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/itemtypetreatments/add`);
		}
	}
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="ItemtypetreatmentsAddPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label=""  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title="Add New Itemtypetreatment"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Itemtypeid *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/itemtypeid_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="itemtypeid"     optionLabel="label" optionValue="value" value={formik.values.itemtypeid} onChange={formik.handleChange} options={response} label="Itemtypeid"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.itemtypeid)}   />
                                                    <ErrorMessage name="itemtypeid" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Treatmentid *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/treatmentid_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="treatmentid"     optionLabel="label" optionValue="value" value={formik.values.treatmentid} onChange={formik.handleChange} options={response} label="Treatmentid"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.treatmentid)}   />
                                                    <ErrorMessage name="treatmentid" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Pricemultiplier 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="pricemultiplier"  onChange={formik.handleChange}  value={formik.values.pricemultiplier}   label="Pricemultiplier" type="number" placeholder="Enter Pricemultiplier"  min={0}  step={0.01}    className={inputClassName(formik?.errors?.pricemultiplier)} />
                                                <ErrorMessage name="pricemultiplier" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Partnerid 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/partnerid_option_list_3"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="partnerid"     optionLabel="label" optionValue="value" value={formik.values.partnerid} onChange={formik.handleChange} options={response} label="Partnerid"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.partnerid)}   />
                                                    <ErrorMessage name="partnerid" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Userid 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="userid"  onChange={formik.handleChange}  value={formik.values.userid}   label="Userid" type="number" placeholder="Enter Userid"  min={0}  step="any" disabled   className={inputClassName(formik?.errors?.userid)} />
                                                <ErrorMessage name="userid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label="Submit" icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
ItemtypetreatmentsAddPage.defaultProps = {
	primaryKey: 'id',
	pageName: 'itemtypetreatments',
	apiPath: 'itemtypetreatments/add',
	routeName: 'itemtypetreatmentsadd',
	submitButtonLabel: "Submit",
	formValidationError: "Form is invalid",
	formValidationMsg: "Please complete the form",
	msgTitle: "Create Record",
	msgAfterSave: "Record added successfully",
	msgBeforeSave: "",
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default ItemtypetreatmentsAddPage;
